export class PipelineResultImpl {
    constructor() {
        this.FACE_ANGLE_TOO_LARGE = false;
        this.FACE_CLOSE_TO_BORDER = false;
        this.FACE_NOT_FOUND = false;
        this.FACE_TOO_SMALL = false;
        this.PROBABILITY_TOO_SMALL = false;
        this.TOO_MANY_FACES = false;
    }
}
